import { AxiosClient } from '@/app/shared/services';

const state = {
    deliveriesList: {
        list: [],
        isLoading: false,
    },
};

const getters = {
    DELIVERIES_LOADING: (state) => state.deliveriesList.isLoading,
    DELIVERIES_LIST: (state) => state.deliveriesList.list,
};

const mutations = {
    SET_DELIVERIES_LIST: (state, settings) => {
        state.deliveriesList.list = settings;
    },
    SET_DELIVERIES_LOADING: (state, isLoading) => {
        state.deliveriesList.isLoading = isLoading;
    },
};

const actions = {
    GET_DELIVERIES_LIST: (context, params) => {
        context.commit('SET_DELIVERIES_LOADING', true);
        return new Promise((resolve, reject) => {
            AxiosClient.get('/notification/get_deliveries', {params})
                .then((response) => {
                    context.commit('SET_DELIVERIES_LIST', response.data);
                    resolve(response);
                })
                .catch(() => reject())
                .finally(() => {
                    context.commit('SET_DELIVERIES_LOADING', false);
                });
        });
    },

    UPDATE_DELIVERIES: (context, delivery) => {
        context.commit("SET_CURRENT_DELIVERIES_LOADING", true);
        return new Promise((resolve, reject) => {
            AxiosClient.post(`/delivery/update/${delivery.id}`, delivery)
                .then((response) => resolve(response.data))
                .catch(() => reject())
                .finally(() => {
                    context.commit("SET_CURRENT_DELIVERIES_LOADING", false);
                });
        });
    },


    PAUSE_DELIVERY: (context, id) => {
        return new Promise((resolve, reject) => {
            AxiosClient.post('/notification/pause/' + id)
                .then((data) => {
                    resolve(data.data);
                })
                .catch((error) => {
                    reject(error);
                })
        })
    },
    RESTART_DELIVERY: (context, id) => {
        return new Promise((resolve, reject) => {
            AxiosClient.post('/notification/restart/' + id)
                .then((data) => {
                    resolve(data.data);
                })
                .catch((error) => {
                    reject(error);
                })
        })
    }

}

export default {
    state,
    getters,
    mutations,
    actions,
};
